import { ActionPlanAppointmentItem } from "../models/ActionPlan";

/**
 * Exporte un Appointment UP CARE sous forme de fichier iCalendar (.ics).
 * Le format est compris nativement par Outlook, mais reste interoperable avec
 * les autres calendriers (Apple Calendar, Google Calendar, etc.).
 */
export function exportAppointmentToOutlook(appointment: ActionPlanAppointmentItem): void {
    if (!appointment.start) return;

    const lines = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//UP CARE//Appointment//FR",
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VEVENT",
        `UID:${escapeIcsText(buildUid(appointment))}`,
        `DTSTAMP:${formatIcsDate(new Date())}`,
        `DTSTART:${formatIcsDate(new Date(appointment.start))}`,
        ...(appointment.end ? [`DTEND:${formatIcsDate(new Date(appointment.end))}`] : []),
        `SUMMARY:${escapeIcsText(appointment.title)}`,
        ...(appointment.location ? [`LOCATION:${escapeIcsText(appointment.location)}`] : []),
        ...(buildDescription(appointment)
            ? [`DESCRIPTION:${escapeIcsText(buildDescription(appointment))}`]
            : []),
        "END:VEVENT",
        "END:VCALENDAR"
    ];

    const blob = new Blob([lines.join("\r\n")], {
        type: "text/calendar;charset=utf-8"
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");

    anchor.href = url;
    anchor.download = `${slugify(appointment.title) || "up-care-appointment"}.ics`;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
}

function buildUid(appointment: ActionPlanAppointmentItem): string {
    const id = appointment.id || slugify(appointment.title) || "appointment";
    return `${id}@up-care.chu-nancy`;
}

function buildDescription(appointment: ActionPlanAppointmentItem): string {
    const sections: string[] = [];

    if (appointment.presenter) {
        sections.push(`Intervenant : ${appointment.presenter}`);
    }

    if (appointment.objectives.length > 0) {
        sections.push(`Objectifs :\n${appointment.objectives.map((objective) => `- ${objective}`).join("\n")}`);
    }

    if (appointment.schedule) {
        sections.push(`Déroulé :\n${appointment.schedule}`);
    }

    return sections.join("\n\n");
}

function formatIcsDate(date: Date): string {
    return date.toISOString()
        .replace(/[-:]/g, "")
        .replace(/\.\d{3}Z$/, "Z");
}

function escapeIcsText(value: string): string {
    return value
        .replace(/\\/g, "\\\\")
        .replace(/\r?\n/g, "\\n")
        .replace(/,/g, "\\,")
        .replace(/;/g, "\\;");
}

function slugify(value: string): string {
    return value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}
